/**
 * Maps club subtypes to their corresponding API filter strings
 * @param {string} clubSubType - The selected club subtype (e.g., "Sand Wedge", "3-Hybrid", "3-Wood")
 * @returns {string[]} Array of filter strings to send to the API
 */
export const getClubSubTypeFilters = (clubSubType) => {
  if (!clubSubType) {
    return [];
  }

  const subTypeMap = {
    // Wedges
    "Sand Wedge": [
      "54Wedge",
      "56Wedge",
      "SandWedge",
    ],
    "Lob Wedge": [
      "58Wedge",
      "60Wedge",
      "LobWedge",
    ],
    "Pitching Wedge": [
      "PitchingWedge",
    ],
    "Gap Wedge": [
      "50Wedge",
      "52Wedge",
    ],

    // Hybrids
    "1-Hybrid": ["1Hybrid"],
    "2-Hybrid": ["2Hybrid"],
    "3-Hybrid": ["3Hybrid"],
    "4-Hybrid": ["4Hybrid"],
    "5-Hybrid": ["5Hybrid"],
    "6-Hybrid": ["6Hybrid"],
    "7-Hybrid": ["7Hybrid"],
    "8-Hybrid": ["8Hybrid"],
    "9-Hybrid": ["9Hybrid"],

    // Woods
    "2-Wood": ["2Wood"],
    "3-Wood": ["3Wood"],
    "4-Wood": ["4Wood"],
    "5-Wood": ["5Wood"],
    "6-Wood": ["6Wood"],
    "7-Wood": ["7Wood"],
    "8-Wood": ["8Wood"],
    "9-Wood": ["9Wood"],
  };

  return subTypeMap[clubSubType] || [];
};
